<template>
  <div class="mb-4">
    <validation-observer v-if="type === 'yearrange'" ref="yrObserver" v-slot="{ errors }">
      <div v-for="(error, name) in errors" :key="name">
        <h6 v-if="displayError(error, 'Year range of ' + number + question.questionText)" class="text-danger">{{ error[0] }}</h6>
      </div>
      <div class="mb-1"><span v-html="number" class="number-text"></span><span v-html="question.questionText"></span></div>
      <div v-html="question.instructions" class="font-italic mb-1"></div>
      <div v-if="debugQuestions" class="text-warning">{{ question.hspCategoryQuestionId }} (state text: {{ stateResponseTextValue }})</div>
      <div class="row">
        <validation-provider name="year1" :disabled="isOptional" slim :immediate="validateImmediate">
          <div class="col-sm-6 col-lg-4">
            <label class="mb-1" :for="`${_uid}-date-picker-from`">From</label>
            <base-input>
              <el-date-picker
                :id="`${_uid}-date-picker-from`"
                class="picker-border"
                :style="{ 'background-color': responsesBackColor }"
                :popper-class="surveyTheme"
                v-model="year1"
                type="year"
                value-format="yyyy"
                :placeholder="placeholder"
                :clearable="isOptional"
                :picker-options="pickerOptions"
                @input="handleYearRangeInput"></el-date-picker>
            </base-input>
          </div>
        </validation-provider>
        <validation-provider name="year2" :rules="{ required: !isOptional, rangeValid: { target: '@year1' } }" :disabled="isOptional" slim :immediate="validateImmediate">
          <div class="col-sm-6 col-lg-4">
            <label class="mb-1" :for="`${_uid}-date-picker-to`">To</label>
            <base-input>
              <el-date-picker
                :id="`${_uid}-date-picker-to`"
                class="picker-border"
                :style="{ 'background-color': responsesBackColor }"
                :popper-class="surveyTheme"
                v-model="year2"
                type="year"
                value-format="yyyy"
                :placeholder="placeholder"
                :clearable="isOptional"
                :picker-options="pickerOptions"
                @input="handleYearRangeInput"></el-date-picker>
            </base-input>
          </div>
        </validation-provider>
      </div>
    </validation-observer>

    <validation-observer v-else ref="dtObserver" v-slot="{ errors }">
      <validation-provider :rules="{ required: !isOptional }" :disabled="isOptional" :immediate="validateImmediate">
        <div v-for="(error, name) in errors" :key="name">
          <h6 v-if="displayError(error, 'Date Time of ' + number + question.questionText)" class="text-danger">{{ error[0] }}</h6>
        </div>
        <label class="mb-1" :style="{ 'background-color': questionBackColor }" :for="`${_uid}-date-picker`"><span v-html="number" class="number-text"></span><span v-html="question.questionText"></span></label>
        <div v-html="question.instructions" class="font-italic mb-1"></div>
        <div v-if="debugQuestions" class="text-warning">{{ question.hspCategoryQuestionId }} (state text: {{ stateResponseTextValue }})</div>
        <div class="row">
          <div class="col-sm-6 col-lg-4">
            <base-input>
              <el-date-picker
                class="picker-border"
                :id="`${_uid}-date-picker`"
                :style="{ 'background-color': responsesBackColor }"
                :popper-class="surveyTheme"
                :value="stateResponseTextValue"
                :type="type"
                :value-format="valueFormat"
                :placeholder="placeholder"
                :clearable="isOptional"
                :picker-options="pickerOptions"
                @input="handleInput"></el-date-picker>
            </base-input>
          </div>
        </div>
      </validation-provider>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { DatePicker } from 'element-ui';
import { mapGetters } from 'vuex';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    [DatePicker.name]: DatePicker
  },
  props: {
    question: {
      type: Object,
      required: true,
      default: function() {
        return {
          responses: []
        }
      }
    },
    number: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    validateImmediate: Boolean,
  },
  data() {
    return {
      type: 'date',
      valueFormat: '',
      placeholder: 'Select a date',
      min: null,
      max: null,
      pickerOptions: {
        disabledDate: this.isDateDisabled
      },
      year1: undefined,
      year2: undefined
    }
  },
  computed: {
    ...mapGetters(['activeSectionId', 'debugQuestions']),
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if(this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    stateResponseTextValue() {
      let responses = this.$store.getters.getQuestionResponses(this.question.hspCategoryQuestionId);

      if(responses.length) {
        return responses[0].responseTextValue;
      }

      return null;
    },
    surveyTheme() {
      let theme = this.$store.getters.themeColor(this.$route.params.surveyId);

      if(theme !== null) {
        return `${theme}-theme`;
      }

      return null;
    }
  },
  methods: {
    displayError(error, description = "") {
      let display = error.length > 0 && error[0].length > 0;
      // console.log("In Datetime.vue -- error:");
      // console.log(error);
      // console.log((description.length > 0 ? "for [" + description + "]: " : "") + "display = [" + display + "]");
      return display;
    },
    handleInput(value) {
      this.$store.dispatch('setQuestionResponse', {
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseText: value
      });
    },
    handleYearRangeInput(value) {
      if(this.year1 && this.year2) {
        this.$store.dispatch('setQuestionResponse', {
          questionTypeId: this.question.hspQuestionTypeId,
          questionId: this.question.hspCategoryQuestionId,
          responseText: `${this.year1}-${this.year2}`
        });
      }
    },
    isDateDisabled(date) {
      if(this.type === 'date') {
        return this.isDayDisabled(date);
      }
      else if(this.type === 'year' || this.type === 'yearrange') {
        return this.isYearDisabled(date.getFullYear());
      }

      return false;
    },
    isDayDisabled(day) {
      let min = this.min === null ? this.min : new Date(this.min);
      let max = this.max === null || this.max === 'now' ? this.max : new Date(this.max);
      let minTest = min === null ? false : day < min;
      let maxTest = false;

      if(max !== null) {
        if(max === 'now') {
          maxTest = day > new Date();
        }
        else {
          maxTest = day > max;
        }
      }

      return minTest || maxTest;
    },
    isYearDisabled(year) {
      let minTest = this.min === null ? false : year < this.min;
      let maxTest = false;

      if(this.max !== null) {
        if(this.max === 'now') {
          maxTest = year > new Date().getFullYear();
        }
        else {
          maxTest = year > this.max;
        }
      }

      return minTest || maxTest;
    }
  },
  created() {
    this.question.questionOptions.forEach(option => {
      if(this.hasOwnProperty(option.optionName)) {
        this[option.optionName] = option.optionValue;
      }
    });

    if(this.type === 'yearrange') {
      let responses = this.$store.getters.getQuestionResponses(this.question.hspCategoryQuestionId);

      if(responses.length) {
        let yearArray = responses[0].responseTextValue.split('-');

        if(yearArray.length === 2) {
          this.year1 = yearArray[0];
          this.year2 = yearArray[1];
        }
      }
    }
  }
}
</script>
<style scoped="true">
.picker-border {
  border-top-left-radius: 0.4285rem;
  border-bottom-left-radius: 0.4285rem;
  border-top-right-radius: 0.4285rem;
  border-bottom-right-radius: 0.4285rem;
}
</style>
